// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal .dialog.system-config {
    --ui-modal-bg: #292d32;
    --ui-modal-header-bg: #4c5fc4;
    top: 50%;
    width: min(940px, calc(100vw - 40px));
    height: min(658px, calc(100vh - 40px));
    padding-bottom: 0;
    overflow: hidden;
    background: var(--ui-modal-bg);
}

.system-config .system-config-main {
    display: grid;
    grid-template-columns: 220px minmax(0, 1fr);
    height: calc(100% - var(--ui-modal-header-height));
}

.system-config .config-tabs {
    padding: 13px 20px;
    background: rgba(4, 6, 8, 0.19);
}

.system-config .config-tab {
    position: relative;
    width: 180px;
    height: 43px;
    padding: 0 10px;
    color: #9ba1a7;
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.system-config .config-tab:hover {
    color: #f8f8f8;
    isolation: isolate;
}

.system-config .config-tab.selected {
    color: #f8f8f8;
    isolation: isolate;
}

.system-config .config-tab:hover::before,
.system-config .config-tab.selected::before {
    position: absolute;
    z-index: -1;
    top: 6px;
    right: 0;
    bottom: 5px;
    left: 0;
    border-radius: var(--ui-modal-radius);
    content: '';
}

.system-config .config-tab:hover::before {
    background: rgba(217, 217, 217, 0.25);
}

.system-config .config-tab.selected::before {
    background: var(--ui-modal-header-bg);
}

.system-config .system-config-body {
    min-width: 0;
    overflow-y: auto;
    padding: 26px 35px;
}

.system-config .system-config-body.midi {
    overflow: hidden;
    /* The MIDI frame begins at y=59; the other Figma frames begin at y=60. */
    padding-top: 25px;
}

.system-config .config-section,
.system-config .config-midi-copy,
.system-config .midi-assignment-copy {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.system-config .config-backup {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.system-config .config-backup > .config-section {
    min-height: 106px;
}

.system-config .config-section-title {
    color: #9dacf3;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: uppercase;
}

.system-config .config-help {
    color: #abaeb1;
    font-size: 13px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.025em;
}

.system-config .config-help a {
    color: #587be5;
}

.system-config .config-actions {
    display: flex;
    gap: 10px;
    /* 9px section gap + 6px margin = Figma's 15px text-to-actions gap. */
    margin-top: 6px;
}

.system-config .config-setting {
    display: flex;
    align-items: center;
    /* Keep the checkbox-label pair on Figma's 7px rhythm. */
    gap: 7px;
    margin-top: 6px;
}

.system-config .config-setting-name {
    color: #dbdcde;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.025em;
}

.system-config .config-switch {
    width: 26px;
    height: 24px;
    flex: 0 0 auto;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: var(--ui-modal-radius);
    background: #2e3236;
    color: var(--ui-button-text-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

/* The switch and the port dropdown trigger are clickable and had no hover at
   all. Both paint their own surface, on or off. */
.system-config .config-switch:hover,
.system-config .config-midi-port-select:hover {
    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));
}

.system-config .config-switch.on {
    border-color: #6e80e0;
    background: #6e80e0;
}

.system-config .config-switch-check {
    display: block;
    flex: 0 0 auto;
}

.system-config .config-action {
    min-width: 91px;
    width: max-content;
    height: 32px;
    padding: 0 10px;
    background: var(--ui-button-bg-primary);
    color: var(--ui-button-text-primary);
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.system-config .config-action:hover {
    color: var(--ui-button-text-primary);
    filter: brightness(1.1);
}

.system-config .config-action.danger {
    background: var(--red-3);
    color: var(--black-20);
}

.system-config .config-midi-port,
.system-config .midi-assignment-head {
    display: flex;
    align-items: flex-end;
    gap: 15px;
}

.system-config .config-midi-copy,
.system-config .midi-assignment-copy {
    flex: 1 1 auto;
    min-width: 0;
}

.system-config .config-midi-port-select {
    width: 275px;
    height: 32px;
    padding: 4px 5px 4px 10px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: var(--ui-modal-radius);
    color: var(--black-80);
    background: #2e3236;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.system-config .config-midi-port-chevron {
    width: 24px;
    height: 24px;
    display: flex;
    flex: 0 0 auto;
}

.system-config .config-midi-port-picker {
    position: relative;
    width: 275px;
    flex: 0 0 auto;
}

.system-config .config-midi-port-options {
    position: absolute;
    z-index: 2;
    top: calc(100% + 4px);
    right: 0;
    left: 0;
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: var(--ui-modal-radius);
    background: #2e3236;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.32);
}

.system-config .config-midi-port-option,
.system-config .config-midi-port-clear {
    min-height: 32px;
    padding: 0 10px;
    color: var(--black-65);
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
}

/* Clear sits in the same list as the port rows, so it takes their highlight
   rather than the generic veil. A different treatment on the last row of a
   dropdown reads as a bug. */
.system-config .config-midi-port-option:hover,
.system-config .config-midi-port-clear:hover,
.system-config .config-midi-port-option.selected {
    color: var(--black-80);
    background: rgba(76, 95, 196, 0.45);
}

.system-config .config-midi-port-option.disconnected {
    color: var(--red-3);
}

.system-config .config-midi-port-option .symbols {
    font-size: 17px;
}

.system-config .config-midi-port-clear {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    color: var(--black-45);
}

.system-config .midi-browser {
    width: 100%;
    margin-top: 20px;
}

.system-config .midi-browser .midi-assignment-head {
    margin-bottom: 15px;
}

.system-config .midi-browser .search {
    width: 275px;
    flex: 0 0 auto;
}

.system-config .midi-browser .searchbox {
    width: 275px;
    height: 32px;
    margin: 0;
    padding: 0 10px 0 35px;
    border-color: rgba(255, 255, 255, 0.15);
    background: #2e3236;
    color: rgba(205, 205, 206, 0.48);
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
    letter-spacing: 0.02em;
}

.system-config .midi-browser .search .icon {
    position: absolute;
    width: 20px;
    height: 20px;
    margin-left: 0;
    font-size: 20px;
    line-height: 20px;
    color: #cdcdce;
}

.system-config .midi-browser .search .icon.search {
    left: 10px;
}

.system-config .midi-browser .search .icon.reset {
    right: 8px;
}

.system-config .midi-browser .searchbox.empty {
    color: rgba(205, 205, 206, 0.48);
}

.system-config .midi-browser .searchbox.edit {
    padding: 0 10px 0 35px;
    color: #cdcdce;
    background: #2e3236;
}

.system-config .midi-browser .midi-table {
    width: 100%;
    height: 373px;
    overflow: hidden;
    border-radius: var(--ui-modal-radius);
    background: #161d23;
}

.system-config .midi-browser .headers {
    height: 32px;
    background: #565d81;
}

.system-config .midi-browser .headers .header,
.system-config .midi-browser .entities .entity {
    height: 32px;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.system-config .midi-browser .headers .header {
    position: static;
    left: auto;
    justify-content: flex-start;
    color: #cdcdce;
}

.system-config .midi-browser .headers .header.note,
.system-config .midi-browser .entities .entity .note {
    width: 103px;
    padding-left: 10px;
    justify-content: flex-start;
}

.system-config .midi-browser .headers .header.cat,
.system-config .midi-browser .entities .entity .cat {
    width: 70px;
    justify-content: center;
}

.system-config .midi-browser .headers .header.name,
.system-config .midi-browser .entities .entity .name {
    width: auto;
    flex: 1 1 auto;
    justify-content: flex-start;
    font-size: 13px;
}

.system-config .midi-browser .headers .header .order {
    flex: 0 0 16px;
    height: 16px;
    margin-left: 2px;
    font-size: 16px;
    line-height: 16px;
    visibility: hidden;
}

.system-config .midi-browser .headers .header.active .order {
    visibility: visible;
}

.system-config .midi-browser .entities {
    width: 720px;
    height: 331px;
    max-height: 331px;
    overflow-y: auto;
    background: #161d23;
}

.system-config .midi-browser .entities .entity {
    color: #717579;
    background: #161d23;
}

.system-config .midi-browser .entities .entity:nth-child(odd):not(.learning) {
    background: #11171d;
}

.system-config .midi-browser .entities .entity .actions {
    width: 30px;
    color: #717579;
}

@media (max-width: 700px) {
    .system-config .system-config-main {
        grid-template-columns: 120px minmax(0, 1fr);
    }

    .system-config .system-config-body {
        padding: 18px;
    }

    .system-config .config-midi-port,
    .system-config .midi-assignment-head {
        align-items: stretch;
        flex-direction: column;
    }

    .system-config .config-midi-port-select,
    .system-config .config-midi-port-picker,
    .system-config .midi-browser .search {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/system-config.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,QAAQ;IACR,qCAAqC;IACrC,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,OAAO;IACP,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yEAAyE;IACzE,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qEAAqE;IACrE,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wDAAwD;IACxD,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,2CAA2C;IAC3C,qCAAqC;IACrC,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;kDACkD;AAClD;;IAEI,uEAAuE;AAC3E;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uCAAuC;IACvC,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;;IAEI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,2CAA2C;IAC3C,qCAAqC;IACrC,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,QAAQ;IACR,OAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;;6BAE6B;AAC7B;;;IAGI,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,uCAAuC;IACvC,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;QACI,2CAA2C;IAC/C;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;;;QAGI,WAAW;IACf;AACJ","sourcesContent":[".modal .dialog.system-config {\n    --ui-modal-bg: #292d32;\n    --ui-modal-header-bg: #4c5fc4;\n    top: 50%;\n    width: min(940px, calc(100vw - 40px));\n    height: min(658px, calc(100vh - 40px));\n    padding-bottom: 0;\n    overflow: hidden;\n    background: var(--ui-modal-bg);\n}\n\n.system-config .system-config-main {\n    display: grid;\n    grid-template-columns: 220px minmax(0, 1fr);\n    height: calc(100% - var(--ui-modal-header-height));\n}\n\n.system-config .config-tabs {\n    padding: 13px 20px;\n    background: rgba(4, 6, 8, 0.19);\n}\n\n.system-config .config-tab {\n    position: relative;\n    width: 180px;\n    height: 43px;\n    padding: 0 10px;\n    color: #9ba1a7;\n    font-size: 15px;\n    font-weight: 700;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n}\n\n.system-config .config-tab:hover {\n    color: #f8f8f8;\n    isolation: isolate;\n}\n\n.system-config .config-tab.selected {\n    color: #f8f8f8;\n    isolation: isolate;\n}\n\n.system-config .config-tab:hover::before,\n.system-config .config-tab.selected::before {\n    position: absolute;\n    z-index: -1;\n    top: 6px;\n    right: 0;\n    bottom: 5px;\n    left: 0;\n    border-radius: var(--ui-modal-radius);\n    content: '';\n}\n\n.system-config .config-tab:hover::before {\n    background: rgba(217, 217, 217, 0.25);\n}\n\n.system-config .config-tab.selected::before {\n    background: var(--ui-modal-header-bg);\n}\n\n.system-config .system-config-body {\n    min-width: 0;\n    overflow-y: auto;\n    padding: 26px 35px;\n}\n\n.system-config .system-config-body.midi {\n    overflow: hidden;\n    /* The MIDI frame begins at y=59; the other Figma frames begin at y=60. */\n    padding-top: 25px;\n}\n\n.system-config .config-section,\n.system-config .config-midi-copy,\n.system-config .midi-assignment-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n}\n\n.system-config .config-backup {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.system-config .config-backup > .config-section {\n    min-height: 106px;\n}\n\n.system-config .config-section-title {\n    color: #9dacf3;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 0;\n    text-transform: uppercase;\n}\n\n.system-config .config-help {\n    color: #abaeb1;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.025em;\n}\n\n.system-config .config-help a {\n    color: #587be5;\n}\n\n.system-config .config-actions {\n    display: flex;\n    gap: 10px;\n    /* 9px section gap + 6px margin = Figma's 15px text-to-actions gap. */\n    margin-top: 6px;\n}\n\n.system-config .config-setting {\n    display: flex;\n    align-items: center;\n    /* Keep the checkbox-label pair on Figma's 7px rhythm. */\n    gap: 7px;\n    margin-top: 6px;\n}\n\n.system-config .config-setting-name {\n    color: #dbdcde;\n    font-size: 13px;\n    font-weight: 500;\n    letter-spacing: 0.025em;\n}\n\n.system-config .config-switch {\n    width: 26px;\n    height: 24px;\n    flex: 0 0 auto;\n    padding: 0;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: var(--ui-modal-radius);\n    background: #2e3236;\n    color: var(--ui-button-text-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n/* The switch and the port dropdown trigger are clickable and had no hover at\n   all. Both paint their own surface, on or off. */\n.system-config .config-switch:hover,\n.system-config .config-midi-port-select:hover {\n    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));\n}\n\n.system-config .config-switch.on {\n    border-color: #6e80e0;\n    background: #6e80e0;\n}\n\n.system-config .config-switch-check {\n    display: block;\n    flex: 0 0 auto;\n}\n\n.system-config .config-action {\n    min-width: 91px;\n    width: max-content;\n    height: 32px;\n    padding: 0 10px;\n    background: var(--ui-button-bg-primary);\n    color: var(--ui-button-text-primary);\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n}\n\n.system-config .config-action:hover {\n    color: var(--ui-button-text-primary);\n    filter: brightness(1.1);\n}\n\n.system-config .config-action.danger {\n    background: var(--red-3);\n    color: var(--black-20);\n}\n\n.system-config .config-midi-port,\n.system-config .midi-assignment-head {\n    display: flex;\n    align-items: flex-end;\n    gap: 15px;\n}\n\n.system-config .config-midi-copy,\n.system-config .midi-assignment-copy {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.system-config .config-midi-port-select {\n    width: 275px;\n    height: 32px;\n    padding: 4px 5px 4px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: var(--ui-modal-radius);\n    color: var(--black-80);\n    background: #2e3236;\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.system-config .config-midi-port-chevron {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    flex: 0 0 auto;\n}\n\n.system-config .config-midi-port-picker {\n    position: relative;\n    width: 275px;\n    flex: 0 0 auto;\n}\n\n.system-config .config-midi-port-options {\n    position: absolute;\n    z-index: 2;\n    top: calc(100% + 4px);\n    right: 0;\n    left: 0;\n    max-height: 250px;\n    overflow-y: auto;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: var(--ui-modal-radius);\n    background: #2e3236;\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.32);\n}\n\n.system-config .config-midi-port-option,\n.system-config .config-midi-port-clear {\n    min-height: 32px;\n    padding: 0 10px;\n    color: var(--black-65);\n    font-size: 13px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    cursor: pointer;\n}\n\n/* Clear sits in the same list as the port rows, so it takes their highlight\n   rather than the generic veil. A different treatment on the last row of a\n   dropdown reads as a bug. */\n.system-config .config-midi-port-option:hover,\n.system-config .config-midi-port-clear:hover,\n.system-config .config-midi-port-option.selected {\n    color: var(--black-80);\n    background: rgba(76, 95, 196, 0.45);\n}\n\n.system-config .config-midi-port-option.disconnected {\n    color: var(--red-3);\n}\n\n.system-config .config-midi-port-option .symbols {\n    font-size: 17px;\n}\n\n.system-config .config-midi-port-clear {\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n    color: var(--black-45);\n}\n\n.system-config .midi-browser {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.system-config .midi-browser .midi-assignment-head {\n    margin-bottom: 15px;\n}\n\n.system-config .midi-browser .search {\n    width: 275px;\n    flex: 0 0 auto;\n}\n\n.system-config .midi-browser .searchbox {\n    width: 275px;\n    height: 32px;\n    margin: 0;\n    padding: 0 10px 0 35px;\n    border-color: rgba(255, 255, 255, 0.15);\n    background: #2e3236;\n    color: rgba(205, 205, 206, 0.48);\n    font-size: 13px;\n    font-style: italic;\n    font-weight: 400;\n    letter-spacing: 0.02em;\n}\n\n.system-config .midi-browser .search .icon {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    margin-left: 0;\n    font-size: 20px;\n    line-height: 20px;\n    color: #cdcdce;\n}\n\n.system-config .midi-browser .search .icon.search {\n    left: 10px;\n}\n\n.system-config .midi-browser .search .icon.reset {\n    right: 8px;\n}\n\n.system-config .midi-browser .searchbox.empty {\n    color: rgba(205, 205, 206, 0.48);\n}\n\n.system-config .midi-browser .searchbox.edit {\n    padding: 0 10px 0 35px;\n    color: #cdcdce;\n    background: #2e3236;\n}\n\n.system-config .midi-browser .midi-table {\n    width: 100%;\n    height: 373px;\n    overflow: hidden;\n    border-radius: var(--ui-modal-radius);\n    background: #161d23;\n}\n\n.system-config .midi-browser .headers {\n    height: 32px;\n    background: #565d81;\n}\n\n.system-config .midi-browser .headers .header,\n.system-config .midi-browser .entities .entity {\n    height: 32px;\n    font-family: 'Inter', sans-serif;\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n}\n\n.system-config .midi-browser .headers .header {\n    position: static;\n    left: auto;\n    justify-content: flex-start;\n    color: #cdcdce;\n}\n\n.system-config .midi-browser .headers .header.note,\n.system-config .midi-browser .entities .entity .note {\n    width: 103px;\n    padding-left: 10px;\n    justify-content: flex-start;\n}\n\n.system-config .midi-browser .headers .header.cat,\n.system-config .midi-browser .entities .entity .cat {\n    width: 70px;\n    justify-content: center;\n}\n\n.system-config .midi-browser .headers .header.name,\n.system-config .midi-browser .entities .entity .name {\n    width: auto;\n    flex: 1 1 auto;\n    justify-content: flex-start;\n    font-size: 13px;\n}\n\n.system-config .midi-browser .headers .header .order {\n    flex: 0 0 16px;\n    height: 16px;\n    margin-left: 2px;\n    font-size: 16px;\n    line-height: 16px;\n    visibility: hidden;\n}\n\n.system-config .midi-browser .headers .header.active .order {\n    visibility: visible;\n}\n\n.system-config .midi-browser .entities {\n    width: 720px;\n    height: 331px;\n    max-height: 331px;\n    overflow-y: auto;\n    background: #161d23;\n}\n\n.system-config .midi-browser .entities .entity {\n    color: #717579;\n    background: #161d23;\n}\n\n.system-config .midi-browser .entities .entity:nth-child(odd):not(.learning) {\n    background: #11171d;\n}\n\n.system-config .midi-browser .entities .entity .actions {\n    width: 30px;\n    color: #717579;\n}\n\n@media (max-width: 700px) {\n    .system-config .system-config-main {\n        grid-template-columns: 120px minmax(0, 1fr);\n    }\n\n    .system-config .system-config-body {\n        padding: 18px;\n    }\n\n    .system-config .config-midi-port,\n    .system-config .midi-assignment-head {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .system-config .config-midi-port-select,\n    .system-config .config-midi-port-picker,\n    .system-config .midi-browser .search {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
